__turbopack_context__.v({
  "btnForgot": "styles-module__AYhjgW__btnForgot",
  "btnResetPassword": "styles-module__AYhjgW__btnResetPassword",
  "btnWrapper": "styles-module__AYhjgW__btnWrapper",
  "formField": "styles-module__AYhjgW__formField",
  "loginForm": "styles-module__AYhjgW__loginForm",
});
